import React, { useState, useEffect, useCallback } from "react"
import "./HeroBanner.css"

const baseURL = process.env.REACT_APP_CMS_URL

function HeroBanner({ slides = [] }) {
  const [current, setCurrent] = useState(0)
  const [fading, setFading] = useState(false)

  const visibleSlides = slides.filter((s) => s.visible !== false)

  const goTo = useCallback(
    (index) => {
      if (index === current || visibleSlides.length <= 1) return
      setFading(true)
      setTimeout(() => {
        setCurrent(index)
        setFading(false)
      }, 300)
    },
    [current, visibleSlides.length],
  )

  useEffect(() => {
    if (visibleSlides.length <= 1) return
    const interval = setInterval(() => {
      const next = (current + 1) % visibleSlides.length
      goTo(next)
    }, 5000)
    return () => clearInterval(interval)
  }, [current, visibleSlides.length, goTo])

  if (visibleSlides.length === 0) return null

  const slide = visibleSlides[current]
  const hasPoster = !!slide.poster

  return (
    <div className="hero-banner">
      <div
        className={[
          "hero-banner__slide",
          hasPoster ? "hero-banner__slide--with-poster" : "",
          fading ? "hero-banner__slide--fading" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="hero-banner__grain" />

        <div className="hero-banner__content">
          <div className="hero-banner__header">
            <span className="hero-banner__badge">{slide.badge}</span>
            {slide.icon && <span className="hero-banner__icon">{slide.icon}</span>}
          </div>

          <h2 className="hero-banner__title">{slide.title}</h2>

          {slide.description && (
            <div
              className="hero-banner__description"
              dangerouslySetInnerHTML={{ __html: slide.description }}
            />
          )}

          <div className="hero-banner__footer">
            <button
              className="hero-banner__cta-btn"
              onClick={(e) => {
                e.stopPropagation()
                slide.onClick?.()
              }}
            >
              {slide.cta || "Ver mais"}
              <span className="hero-banner__cta-shimmer" />
            </button>
            {slide.isNew && (
              <span className="hero-banner__new-label">● Novo</span>
            )}
          </div>
        </div>

        {hasPoster && (
          <img
            className="hero-banner__poster"
            src={`${baseURL}${slide.poster}`}
            alt={slide.title}
          />
        )}
      </div>

      {visibleSlides.length > 1 && (
        <div className="hero-banner__dots">
          {visibleSlides.map((_, i) => (
            <button
              key={i}
              className={`hero-banner__dot ${i === current ? "hero-banner__dot--active" : ""}`}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default HeroBanner
